import FilterParameter from '~/utils/FilterParameter/FilterParameter';
import FilterParameterDescription from '~/utils/FilterParameter/FilterParameterDescription';

import logGoogleTagManagerEvent from './logGoogleTagManagerEvent';
import { FilterOperator } from '~/Api/Product/Query';

export default function logGoogleTagManagerSearchResponse(
	filterParameters: FilterParameter<string | string[]>[],
	availableParameters: FilterParameterDescription<string | string[]>[],
	filterOperator: FilterOperator | null,
	sort: string | null,
	order: string | null,
	timeMilliseconds: number,
	totalResults: number
) {
	const filterParametersMap: { [key: string]: string | string[] | null } = {};
	availableParameters.forEach((parameter) => {
		filterParametersMap[parameter.name] = null;
	});
	filterParameters.forEach((parameter) => {
		filterParametersMap[parameter.name] = parameter.value;
	});

	logGoogleTagManagerEvent({
		event: 'cogvio.searchResponse',
		search: {
			filterParameters: filterParametersMap,
			filterOperator,
			sort,
			order,
			timeMilliseconds,
			totalResults,
		},
	});
}
